import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: '',
    email: '',
    subject: '',
    phone: '',
    message: ''
  });

  const [validator] = useState(new SimpleReactValidator({ className: 'errorMessage' }));
  const [status, setStatus] = useState(null); // for success/error messages
  const [loading, setLoading] = useState(false); // optional, for "sending..."

  const changeHandler = e => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessages(); // keep showing messages live
  };

  const submitHandler = async e => {
    e.preventDefault();

    if (validator.allValid()) {
      setStatus(null);
      setLoading(true);

      try {
        const formData = new FormData();
        for (let key in forms) {
          formData.append(key, forms[key]);
        }

        const res = await fetch('contact.php', {
          method: 'POST',
          body: formData
        });

        const data = await res.json();

        if (data.status === 'success') {
          setStatus({ type: 'success', message: data.message });
          setForms({ name: '', email: '', subject: '', phone: '', message: '' });
        } else {
          setStatus({ type: 'error', message: data.message || 'Something went wrong.' });
        }
      } catch (err) {
        setStatus({ type: 'error', message: 'Network error. Try again.' });
      } finally {
        setLoading(false);
      }
    } else {
      validator.showMessages();
    }
  };

  return (
    <form onSubmit={submitHandler} className="contact-validation-active">
      <div className="row">
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              name="name"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Name"
            />
            {validator.message('name', forms.name, 'required|alpha_space')}
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.email}
              type="email"
              name="email"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Email"
            />
            {validator.message('email', forms.email, 'required|email')}
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.phone}
              type="text"
              name="phone"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Phone"
            />
            {validator.message('phone', forms.phone, 'required|phone')}
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.subject}
              type="text"
              name="subject"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Subject"
            />
            {validator.message('subject', forms.subject, 'required')}
          </div>
        </div>
        <div className="col col-lg-12 col-12">
          <textarea
            value={forms.message}
            name="message"
            onBlur={changeHandler}
            onChange={changeHandler}
            placeholder="Message"
          ></textarea>
          {validator.message('message', forms.message, 'required')}
        </div>
      </div>

      <div className="submit-area">
        <button type="submit" className="theme-btn" disabled={loading}>
          {loading ? 'Sending...' : 'Submit Now'}
        </button>
      </div>

    {status && (
  <div
    style={{
      margin: '1rem auto',
      padding: '1rem',
      maxWidth: '400px',         
      textAlign: 'center',       
      borderRadius: '8px',
      backgroundColor: status.type === 'success' ? '#d4edda' : '#f8d7da',
      color: status.type === 'success' ? '#155724' : '#721c24',
      border: status.type === 'success' ? '1px solid #c3e6cb' : '1px solid #f5c6cb',
    }}
  >
    {status.message}
  </div>
)}


    </form>
  );
};

export default ContactForm;
